module.exports = __webpack_public_path__ + "img/checked_checkbox.8baecfe1.svg";